import { partnerRolesQueryKey } from "@rhc-shared-components/rhc-sso";
import { skipToken, useIsFetching, useQuery } from "@tanstack/react-query";
import type { IErrorType } from "../constants/apiconstants-hydra";
import type { IPartnershipStatus } from "../constants/apiconstants-pfs";

export const usePartnershipStatus = () => {
	const partnerRolesFetchingCount = useIsFetching({ queryKey: partnerRolesQueryKey });
	const query = useQuery<IPartnershipStatus, IErrorType>({
		queryKey: partnerRolesQueryKey,
		queryFn: skipToken,
	});

	return {
		...query,
		isFetching: query.isFetching || partnerRolesFetchingCount > 0 || (query.isPending && !query.data),
	};
};
